import { render, staticRenderFns } from "./legacy_pipelines_table_wrapper.vue?vue&type=template&id=50296cce"
import script from "./legacy_pipelines_table_wrapper.vue?vue&type=script&lang=js"
export * from "./legacy_pipelines_table_wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports